/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SUSPEND_USER: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.klefki.userList.suspendUser",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        START: { target: "SUSPEND_USER" },
      },
    },
    SUSPEND_USER: {
      invoke: {
        id: "suspendUser",
        src: "suspendUser",
        onDone: {
          target: "SUSPEND_USER_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "SUSPEND_USER_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    SUSPEND_USER_SUCCESS: {
      on: {
        START: { target: "SUSPEND_USER" },
      },
    },
    SUSPEND_USER_FAILED: {
      on: {
        START: { target: "SUSPEND_USER" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
